function start_and_end(str) {
    return str;
}

_BannerFlowApp.directive("includeReplace", function () {
    return {
        require: "ngInclude",
        restrict: "A" /* optional */,
        link: function (scope, el, attrs) {
            el.replaceWith(el.children());
        }
    };
});

_BannerFlowApp.directive("ellipsisMiddle", function ($timeout) {
    return {
        restrict: "A",
        require: "ngModel",
        priority: 99,
        link: function (scope, elm, attrs, ngModelCtrl) {
            scope.$watch(attrs.ngModel, function (newValue, oldValue) {
                var str = newValue;
                if (str && str.length > 30) {
                    $(elm).text(str.substr(0, 20) + "..." + str.substr(str.length - 10, str.length));
                } else {
                    $(elm).text(str);
                }
            });
        }
    };
});

_BannerFlowApp.directive("ellipsis", function ($timeout) {
    return {
        restrict: "A",
        require: "ngModel",
        priority: 99,
        link: function (scope, elm, attrs, ngModelCtrl) {
            scope.$watch(attrs.ngModel, function (newValue, oldValue) {
                var str = newValue;
                if (!str) return;
                if (str.length > parseInt(attrs.ellipsis)) {
                    $(elm).html(str.substr(0, parseInt(attrs.ellipsis)) + "...");
                } else {
                    $(elm).html(str);
                }
            });
        }
    };
});

_BannerFlowApp.directive("inverted", function () {
    return {
        require: "ngModel",
        link: function (scope, element, attrs, ngModel) {
            ngModel.$parsers.push(function (val) {
                return !val;
            });
            ngModel.$formatters.push(function (val) {
                return !val;
            });
        }
    };
});

_BannerFlowApp.directive("ngFade", function () {
    return {
        require: "ngModel",
        link: function (scope, element, attrs, ngModel) {
            element.hide();
            scope.$watch(attrs.ngModel, function (newValue, oldValue) {
                element.hide();
                if (newValue) {
                    $(element).fadeIn("slow");
                }
            });
        }
    };
});

_BannerFlowApp.directive("ngLoad", [
    "$parse",
    function ($parse) {
        return {
            restrict: "A",
            link: function (scope, elem, attrs) {
                var fn = $parse(attrs.ngLoad);

                elem.on("load", function (event) {
                    scope.$apply(function () {
                        fn(scope, { $event: event });
                    });
                });
            }
        };
    }
]);

_BannerFlowApp.directive("animateShow", [
    "$parse",
    "$timeout",
    function ($parse, $timeout) {
        return {
            restrict: "A",
            priority: 99999,
            scope: {
                ngShow: "=?"
            },
            link: function (scope, elem, attrs) {
                var doAnimation = function () {
                    if ($($(".modal-dialog"), elem).length > 0) {
                        $($(".modal-dialog"), elem).first().css("opacity", "0");
                        $($(".modal-dialog"), elem).first().css("transform", "scale(0.80)");

                        $timeout(function () {
                            $($(".modal-dialog"), elem)
                                .first()
                                .transition({ opacity: 1, scale: 1 }, 350, "ease");
                        }, 10);
                    } else if ($($(".panel-popup"), elem).length > 0) {
                        $($(".panel-popup"), elem).first().css("opacity", "0");
                        $($(".panel-popup"), elem).first().css("transform", "scale(0.80)");
                        $timeout(function () {
                            $($(".panel-popup"), elem)
                                .first()
                                .transition({ opacity: 1, scale: 1 }, 350, "ease");
                        }, 10);
                    }

                    if ($($(".modal-backdrop"), elem).length > 0) {
                        $($(".modal-backdrop"), elem).first().css("opacity", "0");
                        $timeout(function () {
                            $($(".modal-backdrop"), elem)
                                .first()
                                .transition({ opacity: 1 }, 400, "ease");
                        }, 10);
                    }
                };

                if (scope.ngShow !== null && scope.ngShow !== undefined) {
                    scope.$watch("ngShow", function (newVal, oldVal) {
                        if (newVal) {
                            doAnimation();
                        }
                    });
                }
            }
        };
    }
]);

_BannerFlowApp.directive("animateIf", [
    "$parse",
    "$timeout",
    function ($parse, $timeout) {
        return {
            restrict: "A",
            priority: 0,
            scope: {
                ngShow: "=?"
            },
            link: function (scope, elem, attrs) {
                var doAnimation = function () {
                    if ($(elem).find(".panel.panel-fullscreen").length > 0) {
                        $(elem).find(".panel.panel-fullscreen").first().css("opacity", "0");
                        //$($(".panel.panel-fullscreen"), elem).first().css("transform", "scale(0.80)");

                        $timeout(function () {
                            $(elem)
                                .find(".panel.panel-fullscreen")
                                .first()
                                .transition({ opacity: 1, scale: 1 }, 350, "ease");
                        }, 10);
                    } else if ($(elem).find(".modal-dialog").length > 0) {
                        $(elem).find(".modal-dialog").first().css("opacity", "0");
                        $(elem).find(".modal-dialog").first().css("transform", "scale(0.80)");
                        $timeout(function () {
                            $(elem)
                                .find(".modal-dialog")
                                .first()
                                .transition({ opacity: 1, scale: 1 }, 350, "ease");
                        }, 10);
                    } else if ($(elem).find(".panel-popup").length > 0) {
                        $(elem).find(".panel-popup").first().css("opacity", "0");
                        $(elem).find(".panel-popup").first().css("transform", "scale(0.80)");
                        $timeout(function () {
                            $(elem)
                                .find(".panel-popup")
                                .first()
                                .transition({ opacity: 1, scale: 1 }, 350, "ease");
                        }, 10);
                    } else if ($(elem).find(".item-popup").length > 0) {
                        $(elem).find(".item-popup").first().css("opacity", "0");
                        $(elem).find(".item-popup").first().css("transform", "scale(0.80)");
                        $timeout(function () {
                            $(elem)
                                .find(".item-popup")
                                .first()
                                .transition({ opacity: 1, scale: 1 }, 350, "ease");
                        }, 10);
                    } else if ($(elem).find(".feed-banner-preview").length > 0) {
                        $(elem).find(".feed-banner-preview").first().css("opacity", "0");
                        $(elem).find(".feed-banner-preview").first().css("transform", "scale(0.80)");
                        $timeout(function () {
                            $(elem)
                                .find(".feed-banner-preview")
                                .first()
                                .transition({ opacity: 1, scale: 1 }, 350, "ease");
                        }, 10);
                    }

                    if ($($(".modal-backdrop"), elem).length > 0) {
                        $($(".modal-backdrop"), elem).first().css("opacity", "0");
                        $timeout(function () {
                            $($(".modal-backdrop"), elem)
                                .first()
                                .transition({ opacity: 1 }, 400, "ease");
                        }, 10);
                    }
                };

                doAnimation();
            }
        };
    }
]);

_BannerFlowApp.directive("creditCardFormat", function ($timeout) {
    return {
        restrict: "A",
        priority: 99,
        link: function (scope, elm, attrs, ngModelCtrl) {
            var defaultFormat = /(\d{1,4})/g;
            var defaultInputFormat = /(?:^|\s)(\d{4})$/;

            var cards = [
                {
                    type: "maestro",
                    pattern: /^(5018|5020|5038|6304|6759|676[1-3])/,
                    format: defaultFormat,
                    inputFormat: defaultInputFormat,
                    length: [12, 13, 14, 15, 16, 17, 18, 19],
                    cvcLength: [3],
                    luhn: true
                },
                {
                    type: "dinersclub",
                    pattern: /^(36|38|30[0-5])/,
                    format: defaultFormat,
                    inputFormat: defaultInputFormat,
                    length: [14],
                    cvcLength: [3],
                    luhn: true
                },
                {
                    type: "laser",
                    pattern: /^(6706|6771|6709)/,
                    format: defaultFormat,
                    inputFormat: defaultInputFormat,
                    length: [16, 17, 18, 19],
                    cvcLength: [3],
                    luhn: true
                },
                {
                    type: "jcb",
                    pattern: /^35/,
                    format: defaultFormat,
                    inputFormat: defaultInputFormat,
                    length: [16],
                    cvcLength: [3],
                    luhn: true
                },
                {
                    type: "unionpay",
                    pattern: /^62/,
                    format: defaultFormat,
                    inputFormat: defaultInputFormat,
                    length: [16, 17, 18, 19],
                    cvcLength: [3],
                    luhn: false
                },
                {
                    type: "discover",
                    pattern: /^(6011|65|64[4-9]|622)/,
                    format: defaultFormat,
                    inputFormat: defaultInputFormat,
                    length: [16],
                    cvcLength: [3],
                    luhn: true
                },
                {
                    type: "mastercard",
                    pattern: /^5[1-5]/,
                    format: defaultFormat,
                    inputFormat: defaultInputFormat,
                    length: [16],
                    cvcLength: [3],
                    luhn: true
                },
                {
                    type: "amex",
                    pattern: /^3[47]/,
                    format: /(\d{1,4})(\d{1,6})?(\d{1,5})?/,
                    inputFormat: /^(\d{4}|\d{4}\s\d{6})$/,
                    length: [15],
                    cvcLength: [3, 4],
                    luhn: true
                },
                {
                    type: "visa",
                    pattern: /^4/,
                    format: defaultFormat,
                    inputFormat: defaultInputFormat,
                    length: [13, 14, 15, 16],
                    cvcLength: [3],
                    luhn: true
                }
            ];

            var _fromNumber = function (num) {
                var card, i, len;

                num = (num + "").replace(/\D/g, "");

                for (i = 0, len = cards.length; i < len; i++) {
                    card = cards[i];

                    if (card.pattern.test(num)) {
                        return card;
                    }
                }
            };

            var _formatCardNumber = function (e) {
                var $target, card, digit, length, re, upperLength, value;

                digit = String.fromCharCode(e.which);
                $target = angular.element(e.currentTarget);
                value = $target.val();
                card = _fromNumber(value + digit);
                length = (value.replace(/\D/g, "") + digit).length;

                upperLength = 16;

                if (e.which === 8) return;

                if (card) {
                    upperLength = card.length[card.length.length - 1];
                }

                if (length >= upperLength) {
                    return;
                }

                if (!/^\d+$/.test(digit) && !e.meta && e.keyCode >= 46) {
                    e.preventDefault();
                    return;
                }

                if (
                    $target.prop("selectionStart") != null &&
                    $target.prop("selectionStart") !== value.length
                ) {
                    return;
                }

                re = defaultInputFormat;
                if (card) {
                    re = card.inputFormat;
                }

                if (re.test(value)) {
                    e.preventDefault();
                    return $target.val(value + " " + digit);
                } else if (re.test(value + digit)) {
                    e.preventDefault();
                    return $target.val(value + digit + " ");
                }
            };

            var _getFormattedCardNumber = function (num) {
                var card, groups, upperLength, ref;

                card = _fromNumber(num);

                if (!card) {
                    return num;
                }

                upperLength = card.length[card.length.length - 1];
                num = num.replace(/\D/g, "");
                num = num.slice(0, +upperLength + 1 || 9e9);

                if (card.format.global) {
                    return (ref = num.match(card.format)) != null ? ref.join(" ") : void 0;
                } else {
                    groups = card.format.exec(num);

                    if (groups != null) {
                        groups.shift();
                    }

                    return groups != null ? groups.join(" ") : void 0;
                }
            };

            var _reFormatCardNumber = function (e) {
                return setTimeout(function () {
                    var $target, value;
                    $target = angular.element(e.target);

                    value = $target.val();
                    value = _getFormattedCardNumber(value);
                    return $target.val(value);
                });
            };

            var _formatBackCardNumber = function (e) {
                var $target, value;

                $target = angular.element(e.currentTarget);
                value = $target.val();

                if (e.meta) {
                    return;
                }

                if (e.which !== 8) {
                    return;
                }

                if (
                    $target.prop("selectionStart") != null &&
                    $target.prop("selectionStart") !== value.length
                ) {
                    return;
                }

                if (/\d\s$/.test(value) && !e.meta && e.keyCode >= 46) {
                    e.preventDefault();
                    return $target.val(value.replace(/\d\s$/, ""));
                } else if (/\s\d?$/.test(value)) {
                    e.preventDefault();
                    return $target.val(value.replace(/\s\d?$/, ""));
                }
            };

            elm.bind("keydown", _formatBackCardNumber);
            elm.bind("keypress", _formatCardNumber);
            elm.bind("paste", _reFormatCardNumber);
        }
    };
});

_BannerFlowApp.directive("compile", [
    "$compile",
    function ($compile) {
        return function (scope, element, attrs) {
            scope.$watch(
                function (scope) {
                    return scope.$eval(attrs.compile);
                },
                function (value) {
                    element.html(value);
                    $compile(element.contents())(scope);
                }
            );
        };
    }
]);

_BannerFlowApp.directive("tileSize", function () {
    return {
        scope: {
            tileSize: "=",
            ratio: "@"
        },
        link: function (scope, element, attrs, ngModel) {
            var size = scope.tileSize;

            if (!size) return;

            var ratio = parseFloat(scope.ratio);

            // $(element).css("transform", "scale({0})".format(ratio));
            $(element).css("width", size.width * ratio + "px");
            $(element).css("height", size.height * ratio + "px");
        }
    };
});

_BannerFlowApp.directive("tile", function () {
    return {
        link: function (scope, element, attrs, ngModel) {
            $(element).freetile({
                animate: true,
                containerAnimate: true,
                csstransforms3d: true,
                scoreFunction: function (o) {
                    return -o.TestedTop * 8 - o.TestedLeft;
                }
            });
        }
    };
});

_BannerFlowApp.directive("bannerPreview", function ($window) {
    return {
        restrict: "A",
        require: "ngModel",
        priority: 0,
        link: function (scope, elm, attrs, ngModelCtrl) {
            scope.$watch(attrs.ngModel, function (newValue, oldValue) {
                //console.log("schasdad ");
            });
        }
    };
});

_BannerFlowApp.directive("draggable", function ($window) {
    return {
        scope: {
            dragStart: "&",
            draggable: "=",
            campaign: "="
        },
        link: function (scope, element, attrs, ngModel) {
            if (scope.draggable) {
                $(element)
                    .draggable({
                        appendTo: "body",
                        cursorAt: {
                            left: 60,
                            top: 10
                        },
                        beforeStart: function () {
                            if (scope.dragStart) {
                                scope.$apply(function () {
                                    scope.dragStart();
                                });
                            }
                        },
                        // start: function (event, ui) {
                        //     $(this).draggable("option", "cursorAt", {
                        //         left: Math.floor(ui.helper.width() / 2),
                        //         top: Math.floor(ui.helper.height() / 2)
                        //     });
                        // },
                        drag: function (event, ui) {
                            ui.position.top = ui.position.top - $window.scrollY;
                        },
                        helper: function () {
                            return $(
                                "<div class='schedule-item-drag-helper' style='background:{0}'>{1}</div>".format(
                                    scope.campaign.color,
                                    scope.campaign.name
                                )
                            ).data("data", angular.copy(scope.campaign));
                        }
                    })
                    .data("data", angular.copy(scope.campaign));
            }
        }
    };
});

_BannerFlowApp.directive("script", function ($timeout) {
    return {
        restrict: "E",
        scope: false,
        link: function (scope, elem, attr) {
            if (attr.type == "text/javascript-lazy") {
                var code = elem.text();
                var f = new Function(code);
                f();
            }
        }
    };
});

_BannerFlowApp.directive("bfBanner", function ($timeout) {
    return {
        restrict: "E",
        scope: {
            url: "@?"
        },
        link: function (scope, elem, attr) {
            var banner = $("<script src='{0}'></script>".format(scope.url));
            elem.after(banner);
        }
    };
});

_BannerFlowApp.directive("onEnter", [
    "$timeout",
    function ($timeout) {
        return {
            restrict: "A",
            priority: 0,
            link: function (scope, elem, attrs) {
                $(elem).on("keydown", function (event) {
                    if (event.which === 13) {
                        scope.$apply(function () {
                            scope.$eval(attrs.onEnter);
                        });
                        event.preventDefault();
                    }
                });
            }
        };
    }
]);

_BannerFlowApp.directive("panelPagination", [
    "$timeout",
    "$interval",
    function ($timeout, $interval) {
        return {
            restrict: "E",
            require: "ngModel",
            scope: {
                items: "=",
                auto: "@?",
                delay: "@?"
            },
            priority: 99999,
            template:
                '<div class="pages" ng-if="items"><div class="page" ng-click="gotoPage(item, true)" ng-class="{ current : item === selectedItem }" ng-repeat="item in items"></div></div>',
            link: function (scope, elem, attrs, ngModel) {
                scope.index = 0;
                scope.delay = scope.delay ? parseInt(scope.delay) : 10000;

                scope.gotoPage = function (page, click) {
                    if (click && scope.int) {
                        $interval.cancel(scope.int);
                    }

                    ngModel.$setViewValue(null);

                    $timeout(function () {
                        ngModel.$setViewValue(page);
                    }, 10);
                };

                scope.$watch(
                    function () {
                        return ngModel.$modelValue;
                    },
                    function (newValue, oldValue) {
                        scope.selectedItem = newValue;
                    }
                );

                if (scope.auto) {
                    scope.int = $interval(function () {
                        scope.index++;

                        if (scope.index > scope.items.length - 1) scope.index = 0;

                        scope.gotoPage(scope.items[scope.index]);
                    }, scope.delay);
                }
            }
        };
    }
]);

_BannerFlowApp.directive("gridster", [
    "$timeout",
    function ($timeout) {
        return {
            restrict: "A",
            priority: 99999,
            link: function (scope, element, attrs) {
                $timeout(function () {
                    $("#dashboard-grid").css("opacity", "0");

                    var wall = new Freewall("#dashboard-grid");
                    wall.reset({
                        fixSize: 0,
                        animate: true,
                        cellW: 330,
                        cellH: "auto",
                        onResize: function () {
                            $timeout(function () {
                                $(document).trigger("resize");
                            }, 500);

                            wall.fitWidth();
                        }
                    });

                    wall.fitWidth();

                    $timeout(function () {
                        $("#dashboard-grid").transition({ opacity: 1 }, 250);
                    }, 600);
                }, 10);
            }
        };
    }
]);

_BannerFlowApp.directive("timedFade", function ($timeout, $parse) {
    return {
        link: function (scope, element, attrs, ngModel) {
            var fresh = $parse(element.attr("timed-fade"))(scope);

            if (!fresh) return;

            $(element).hide();
            $(element).addClass("animate");

            $timeout(
                function () {
                    $(element).show();
                },
                (scope.$index + 1) * 150
            );
        }
    };
});

_BannerFlowApp.directive("dynamicCtrl", [
    "$compile",
    "$parse",
    function ($compile, $parse) {
        return {
            restrict: "A",
            terminal: true,
            priority: 100000,
            link: function (scope, elem) {
                var name = $parse(elem.attr("dynamic-ctrl"))(scope);
                elem.removeAttr("dynamic-ctrl");
                elem.attr("ng-controller", name);
                $compile(elem)(scope);
            }
        };
    }
]);

_BannerFlowApp.directive("countingNumbers", [
    "$compile",
    "$parse",
    function ($compile, $parse) {
        return {
            restrict: "A",
            terminal: true,
            priority: 100000,
            link: function (scope, elem) {
                var settings = {
                    interval: 70
                };

                var counter = {
                    startValue: parseInt($(elem).attr("data-start-value"), 10),
                    startDate: new Date($(elem).attr("data-start-date")),
                    increase: parseInt($(elem).attr("data-increase"), 10)
                };

                //Calculate increase per interval
                var increasePerSecond = counter.increase / (24 * 60 * 60); /// (1000 / settings.interval);
                var increasePerInterval = increasePerSecond / (1000 / settings.interval);

                function tick() {
                    var seconds = (Date.now() - counter.startDate.getTime()) / 1000;
                    var value = Math.roundTo(counter.startValue + increasePerSecond * seconds, 1);
                    //$(elem).text(numeral(value).format('0,0'));
                    $(elem).text(value);
                }

                setInterval(tick, settings.interval);
            }
        };
    }
]);

_BannerFlowApp.directive("bfMaxLength", [
    "$compile",
    "$log",
    function ($compile, $log) {
        return {
            restrict: "A",
            require: "ngModel",
            link: function (scope, elem, attrs, ctrl) {
                attrs.$set("ngTrim", "false");
                var maxlength = parseInt(attrs.bfMaxLength, 10);
                ctrl.$parsers.push(function (value) {
                    if (value.length > maxlength) {
                        value = value.substr(0, maxlength);
                        ctrl.$setViewValue(value);
                        ctrl.$render();
                    }
                    return value;
                });
            }
        };
    }
]);

_BannerFlowApp.directive("onlyDigits", function () {
    return {
        restrict: "A",
        require: "?ngModel",
        link: function (scope, element, attrs, modelCtrl) {
            modelCtrl.$parsers.push(function (inputValue) {
                if (inputValue == undefined) return "";
                var transformedInput = inputValue.replace(/[^0-9]/g, "");
                if (transformedInput !== inputValue) {
                    modelCtrl.$setViewValue(transformedInput);
                    modelCtrl.$render();
                }
                return transformedInput;
            });
        }
    };
});

_BannerFlowApp.directive("bfAutofocus", [
    "$document",
    function ($document) {
        return {
            link: function ($scope, $element, attrs) {
                setTimeout(function () {
                    $element[0].focus();
                }, 100);
            }
        };
    }
]);
